import {LitElement} from "lit";
import {Subject} from "rxjs";
import {TranslationController} from "../controllers/translation.controller";

export abstract class AbstractLitElement extends LitElement {

    protected readonly _disconnected$ = new Subject<void>();

    public constructor() {
        super();
        new TranslationController(this);
    }

    public createRenderRoot(): AbstractLitElement {
        return this;
    }

    public disconnectedCallback() {
        this._disconnected$.next();
        this._disconnected$.complete();
        super.disconnectedCallback();
    }

    /**
     * Dispatches a custom event with the provided value
     * @param value The value to dispatch
     * @param eventName The name of the event to dispatch (default: 'value-changed')
     */
    public fire<TData>(value: TData, eventName = 'value-changed'): void {
        this.dispatchEvent(new CustomEvent<{ value: TData }>(eventName, {detail: {value}}))
    }

}
